const accordions = {
    init() {
        $('.accordion-title').on('click', function() {
            const parent = $(this).parent();
            $(this).next('.accordion-content').slideDown();

            if (parent.hasClass('active')) {
                parent.removeClass('active');
                $(this).next('.accordion-content').slideUp();
            } else {
                // $('.accordion-item.active').removeClass('active').find('.accordion-content').slideUp();
                // parent.addClass('active');
                parent.addClass('active');
            }

        });
    }
}

export {accordions}